import styled from 'styled-components'
import Tooltip from '@material-ui/core/Tooltip'

export const IconWrapper = styled.span`
  width: 30px;
  padding: 0.25rem;
  display: block;
`

export const StyledIconTooltip = styled(Tooltip)`
  flex: auto;
  width: inherit;
  padding: 0;
  margin: 0;
  text-align: justify;
`

export const StyledPosterContainer = styled.div`
  display: flex;
`
